module.exports = __webpack_public_path__ + "static/media/DEFAULT_MEDIUM_IMAGE_4.d66c00b7.gif";